import React from 'react'
import { Sizes } from '@constants/sizes'
import { Container } from '@shared/components/container'
import { FullLogo } from '@shared/components/logo'
import { Burger } from '@shared/components/top-menu/shared/burger'
import { TopMenuLogin } from '@shared/components/top-menu/shared/login'
import { TopMenuList } from '@shared/components/top-menu/shared/menu-list'
import Link from 'next/link'

import { IStateProps } from './model'

import styles from './style.module.scss'

export const View = ({
	width,
	screensizeParams: { isTablet, isMobile, isDesktop },
	EndAdornment,
	content,
	isLogoHidden,
	onOpenPopupMenu,
	hideLinksList = false,
}: IStateProps) => {
	const showMenu = hideLinksList ? false : !isMobile && +width! > Sizes.fixedMenuShowNavBreakpoint

	return (
		<header className={styles.wrap}>
			<Container className={styles.container}>
				{!isLogoHidden && (
					<Link href='/' className={styles.logoWrap}>
						<FullLogo className={styles.logo} />
					</Link>
				)}
				{content || (
					<>
						{showMenu && <TopMenuList />}
						<div className={styles.controls}>
							{isDesktop && (
								<>
									{EndAdornment ? <EndAdornment /> : <TopMenuLogin />}
									{!showMenu && <Burger onClick={onOpenPopupMenu} active={false} />}
								</>
							)}
							{isTablet && (
								<>
									{EndAdornment && <EndAdornment />}
									<Burger onClick={onOpenPopupMenu} active={false} />
								</>
							)}
						</div>
					</>
				)}
			</Container>
		</header>
	)
}
